/* ==========================================================================
   assets/rh-home.js
   Header (mobile drawer, All Categories panel, menu dropdowns, scroll shadow),
   product carousels, cart count badge.
   ========================================================================== */
(() => {
  if (window.__rhHomeInit) return;
  window.__rhHomeInit = true;

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Mobile drawer ---------- */
  let drawerOpener = null;

  const openDrawer = (button) => {
    const drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer) return;
    drawerOpener = button;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('rh-lock');
    button.setAttribute('aria-expanded', 'true');
    const close = qs('.rh-drawer__close', drawer);
    if (close) close.focus();
  };

  const closeDrawer = () => {
    const drawer = qs('[data-rh-drawer].is-open');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('rh-lock');
    if (drawerOpener) {
      drawerOpener.setAttribute('aria-expanded', 'false');
      drawerOpener.focus();
    }
  };

  /* ---------- All Categories panel ---------- */
  const setAllCats = (button, open) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    panel.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const closeAllCats = (except) => {
    qsa('.rh-allcats__btn[aria-expanded="true"]').forEach((btn) => {
      if (btn !== except) setAllCats(btn, false);
    });
  };

  const closeDropdowns = (except) => {
    qsa('[data-rh-dropdown][open]').forEach((d) => {
      if (d !== except) d.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-rh-drawer-open]');
    if (opener) {
      openDrawer(opener);
      return;
    }

    if (event.target.closest('[data-rh-drawer-close]')) {
      closeDrawer();
      return;
    }

    const allCatsBtn = event.target.closest('.rh-allcats__btn');
    if (allCatsBtn) {
      const open = allCatsBtn.getAttribute('aria-expanded') !== 'true';
      closeDropdowns();
      setAllCats(allCatsBtn, open);
      return;
    }

    // Click outside closes the panel and dropdowns
    if (!event.target.closest('.rh-allcats__panel')) closeAllCats();
    const dropdown = event.target.closest('[data-rh-dropdown]');
    closeDropdowns(dropdown);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeDrawer();
    const openBtn = qs('.rh-allcats__btn[aria-expanded="true"]');
    if (openBtn) {
      setAllCats(openBtn, false);
      openBtn.focus();
    }
    closeDropdowns();
  });

  /* ---------- Header shadow on scroll ---------- */
  const header = qs('[data-rh-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Carousels ---------- */
  const initCarousel = (root) => {
    if (root.dataset.rhReady) return;
    const track = qs('[data-rh-track]', root);
    const prev = qs('[data-rh-prev]', root);
    const next = qs('[data-rh-next]', root);
    if (!track || !prev || !next) return;
    root.dataset.rhReady = 'true';

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };

    const step = () => {
      const item = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const itemWidth = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      return Math.max(itemWidth, Math.floor(track.clientWidth / itemWidth) * itemWidth);
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const initAll = (root = document) => qsa('[data-rh-carousel]', root).forEach(initCarousel);

  /* ---------- Cart count badge ---------- */
  document.addEventListener('cp:cart-added', (event) => {
    const count = event.detail && event.detail.cart ? event.detail.cart.item_count : null;
    if (count == null) return;
    qsa('.rh-cart__count').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
